export const SPECIES_LABEL = {
  canine: 'Canino',
  feline: 'Felino',
  bird: 'Ave',
  rodent: 'Roedor',
  rabbit: 'Coelho',
  reptile: 'Réptil',
  equine: 'Equino',
  bovine: 'Bovino',
  caprine: 'Caprino',
  ovine: 'Ovino',
  swine: 'Suíno',
  fish: 'Peixe',
  exotic: 'Exótico',
  other: 'Outro',
};

export const getSpeciesLabel = (species) => SPECIES_LABEL[species] || species || '—';

/**
 * Formata um número de telefone brasileiro
 * @param {string} phone - Número de telefone
 * @returns {string} - Telefone formatado ou "Não informado"
 */
export const formatPhone = (phone) => {
  if (!phone) return 'Não informado';
  
  let numbers = phone.replace(/\D/g, '');

  // Remove código do país se presente
  if (numbers.startsWith('55') && numbers.length === 13) {
    numbers = numbers.slice(2);
  }
  
  // Formato: (XX) XXXXX-XXXX
  if (numbers.length === 11) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
  }

  // Formato: (XX) XXXX-XXXX
  if (numbers.length === 10) {
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
  }

  return phone;
};

/**
 * Detecta o tipo de documento (CPF, CNPJ ou CRMV)
 * @param {string} doc - Documento
 * @returns {string} - Tipo do documento
 */
export const getDocumentType = (doc) => {
  if (!doc) return 'Documento';
  const cleaned = doc.replace(/\D/g, '');
  
  // Se contém letras, provavelmente é CRMV
  if (/[a-zA-Z]/.test(doc)) return 'CRMV';
  
  if (cleaned.length === 11) return 'CPF';
  if (cleaned.length === 14) return 'CNPJ';
  
  return 'Documento';
};

/**
 * Formata um documento (CPF, CNPJ ou CRMV)
 * @param {string} doc - Documento
 * @returns {string} - Documento formatado ou "Não informado"
 */
export const formatDocument = (doc) => {
  if (!doc) return 'Não informado';
  
  // Se contém letras, é CRMV - retornar como está
  if (/[a-zA-Z]/.test(doc)) {
    return doc.toUpperCase();
  }
  
  const cleaned = doc.replace(/\D/g, '');
  
  // CPF: 11 dígitos - formato: 000.000.000-00
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  
  // CNPJ: 14 dígitos - formato: 00.000.000/0000-00
  if (cleaned.length === 14) {
    return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
  
  // Se não conseguir formatar, retornar como está
  return doc;
};
